module.exports = __webpack_public_path__ + "img/heaven_and_earth_box.474476ce.png";